import React from "react";
import { InventoryContent } from "../../content/inventory/inventoryList";
import { Layout } from "../../layout/page";

export function Inventory() {
  return (
    <Layout>
      <InventoryContent />
    </Layout>
  );
}
